module.exports = __webpack_public_path__ + "static/media/ssr-ticket24afac3d0fe4086b6bf70aaec501a203.webp";